// A button that calls one Livewire action and ignores presses while that round trip runs,
// by mouse or by Enter, without disabling the button: a disabled button drops focus to
// <body> in Chromium.
//
// The guard lets go however the round trip ends. A `$wire.method()` promise settles only on
// a successful response: on a dropped connection or an error status Livewire runs the
// commit's fail hooks and never resolves or rejects it (requestCall() and
// Commit.toRequestPayload() in livewire.esm.js, 3.7.13), so a guard released in `.finally()`
// stayed shut until a reload. The commit hook's `respond` runs on both paths.
export default (method) => ({
    busy: false,

    press() {
        if (this.busy) {
            return;
        }

        this.busy = true;

        const stop = window.Livewire.hook('commit', ({ component, commit, respond }) => {
            if (component.id !== this.$wire.$id || !commit.calls.some((call) => call.method === method)) {
                return;
            }

            stop();
            respond(() => {
                this.busy = false;
            });
        });

        this.$wire[method]();
    },
});
